﻿<script setup>
import { ref, watch, onMounted, nextTick } from 'vue'

const props = defineProps({
	title: { type: String},
	modelValue: { type: Boolean, default: false }
})

const emit = defineEmits(['update:modelValue'])
const isOpen = ref(false)

const contentRef = ref(null)
const innerContent = ref(null)
const contentHeight = ref(0)

onMounted(() => {
	isOpen.value = props.modelValue
	updateHeight()
})

watch(isOpen, () => {
	nextTick(updateHeight)
})

watch(
	() => props.modelValue,
	(val) => {
		isOpen.value = val
	}
)

const toggle = () => {
	isOpen.value = !isOpen.value
	emit('update:modelValue', isOpen.value)
}

// Calculate inner content height for smooth slide
const updateHeight = () => {
	if (innerContent.value) {
		contentHeight.value = innerContent.value.offsetHeight
	}
}

</script>

<template>
	<div class="overflow-hidden">
		<button
			v-if="title"
			class="w-full text-left px-4 py-3 bg-gray-100 hover:bg-gray-200 focus:outline-none flex justify-between items-center"
			@click="toggle"
			:aria-expanded="isOpen"
		>
			<span>{{ title }}</span>
			<svg
				:class="{'transform rotate-180': isOpen}"
				class="w-5 h-5 transition-transform duration-300"
				fill="none"
				stroke="currentColor"
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
			</svg>
		</button>
		<div
			ref="contentRef"
			class="overflow-hidden transition-all duration-300"
			:style="{ maxHeight: isOpen ? contentHeight + 'px' : '0' }"
			:inert="!isOpen"
		>
			<div ref="innerContent">
				<slot></slot>
			</div>
		</div>
	</div>
</template>


